import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { User } from '../../Interfaces/bucket/User'
import { Game } from '../../Interfaces/bucket/Game'
import { Lobby } from '../../Interfaces/bucket/Lobby'

type statusType = 'stateless' | 'pending' | 'start' | 'play'

export interface GameState {
    status?: statusType,
    game_players: User[],
    game?: Game;
    lobby?: Lobby;
    joinedLobbyId: number;
    userInteract?: boolean
}

const initialState: GameState = {
    status: "stateless",
    game_players: [],
    joinedLobbyId: 0,
    userInteract: false
}

export const gameSlice = createSlice({
    name: 'game',
    initialState,
    reducers: {
        changeGame: (state, action: PayloadAction<Game>) => {
            state.game = action.payload
            return state
        },
        changeLobby: (state, action: PayloadAction<Lobby>) => {
            state.lobby = action.payload
            return state
        },
        changeJoinedLobby: (state, action: PayloadAction<number>) => {
            state.joinedLobbyId = action.payload
            return state
        },
        changeStatus: (state, action: PayloadAction<statusType>) => {
            state.status = action.payload
            return state
        },
        changeGamePlayers: (state, action: PayloadAction<User[]>) => {
            state.game_players = action.payload
            return state
        },
        userInteracted(state, action: PayloadAction<boolean>) {
            state.userInteract = action.payload
            return state
        }
    },
})

// Action creators are generated for each case reducer function
export const { changeGame, changeStatus, changeLobby, changeGamePlayers, changeJoinedLobby,userInteracted } = gameSlice.actions

export default gameSlice.reducer


// game_players: [
//     {
//         "_id": "62ebdb3d6245660621554cf7",
//         "wallet": "0x52810d548ae1392d8de18ffbe5f102fa6983e220",
//         "identity": "62ebdb3c95808e002c89d7ef",
//         "nick_name": "davuttrg",
//         "image": "https://storage.googleapis.com/download/storage/v1/b/hq-slime-shadies-f1a50/o/62f3d33095808e002c89e02b?alt=media",
//         "scores": {
//             "kill": 14,
//             "damage": 1474,
//             "win": 43,
//             "rank": 3
//         }
//     },
//     {
//         "_id": "6329dc4594e75cc18700abae",
//         "wallet": "0x35d02a0c72b88e891e0b0640cab0e2f9ccd70929",
//         "identity": "6329dc451f0c35002bf28283",
//         "nick_name": "davuttrg2",
//         "scores": {
//             "kill": 1,
//             "win": 54,
//             "damage": 921,
//             "rank": 1
//         }
//     }
// ],
// game:{
//     "_id": "633d8df7352f6eb03729ce1e",
//     "players": [
//         {
//             "_id": "62ebdb3d6245660621554cf7",
//             "wallet": "0x52810d548ae1392d8de18ffbe5f102fa6983e220",
//             "identity": "62ebdb3c95808e002c89d7ef",
//             "nick_name": "davuttrg",
//             "image": "https://storage.googleapis.com/download/storage/v1/b/hq-slime-shadies-f1a50/o/62f3d33095808e002c89e02b?alt=media",
//             "scores": {
//                 "kill": 14,
//                 "damage": 1474,
//                 "win": 43,
//                 "rank": 3
//             }
//         },
//         {
//             "_id": "6329dc4594e75cc18700abae",
//             "wallet": "0x35d02a0c72b88e891e0b0640cab0e2f9ccd70929",
//             "identity": "6329dc451f0c35002bf28283",
//             "nick_name": "davuttrg2",
//             "scores": {
//                 "kill": 1,
//                 "win": 54,
//                 "damage": 921,
//                 "rank": 1
//             }
//         }
//     ],
//     "title": "Battle 675",
//     "game_id": 675,
//     "created_at": "2022-10-05T14:00:23.463Z",
//     "status": "ENDED",
//     "game_settings": {
//         "delay_turn_pass": 1,
//         "total_game_duration": 500,
//         "turn_duration": 30
//     },
//     "server_settings": {
//         "uri": "wss://mert-test-0002-af932.hq.spicaengine.com/game/3",
//         "port": "7772"
//     },
//     "status_of_players": [
//         {
//             "player": "6329dc4594e75cc18700abae",
//             "status": 0
//         },
//         {
//             "player": "62ebdb3d6245660621554cf7",
//             "status": 0
//         }
//     ],
//     "server_ready": true,
//     "winner": "62ebdb3d6245660621554cf7"
// }